interface CurrencyRates {
  [key: string]: number;
}

export class CurrencyCalculator {
  convertCurrency(
  amount: number,
  fromCurrency: string,
  toCurrency: string,
  rates: CurrencyRates
): number {
  if (!rates[fromCurrency] || !rates[toCurrency]) {
    throw new Error(`Unsupported currency: ${fromCurrency} or ${toCurrency}`);
  }

  // convert amount to USD base first
  const amountInUSD = amount / rates[fromCurrency];

  // then convert from USD to target currency
  const converted = amountInUSD * rates[toCurrency];

  return converted;
}
}